<template>
  <v-autocomplete
    v-model="valeur"
    :items="items"
    :search-input.sync="search"
    :item-text="libelle"
    item-value="id"
    return-object
    v-bind="$attrs"
    autocomplete="off"
    @click:clear="cleared"
  />
</template>

<script>
import _ from 'lodash';

export default {
  props: {
    type: {
      type: String,
    },
    value: {
      type: Object,
    },
    parametresRecherche: {
      // des parametres de recherches en plus
      type: Object,
    },
  },
  data() {
    const withValue = !!this.value;
    const value = this.value || {};
    return {
      items: withValue ? [value] : [],
      search: value.libelle || '',
      valeur: value,
    };
  },
  mounted() {
    this._autocomplete = _.debounce(this.autocomplete, 200, {
      leading: true,
    });
  },
  computed: {
    libelle() {
      if (this.type === 'ville') {
        return item => `${item.libelle} (${item.codePostal})`;
      } else {
        return item => item.libelle;
      }
    },
  },
  watch: {
    search() {
      this._autocomplete();
    },
    valeur() {
      const valeur = JSON.parse(JSON.stringify(this.valeur));
      this.$emit('input', valeur);
    },
    parametresRecherche() {
      this.autocomplete();
    },
  },
  methods: {
    cleared() {
      this.$emit('input', null);
    },
    autocomplete() {
      var params = {};
      //rajoute des parametres de base
      if (this.parametresRecherche) {
        params = JSON.parse(JSON.stringify(this.parametresRecherche));
      }

      //ecrase le libelle
      if (this.type === 'ville' && this.search) {
        params.libelle = this.search.split('(')[0].trim();
      } else {
        params.libelle = this.search;
      }
      params.sort = 'libelle,ASC';
      params.actif = true;

      this.$api(`abstractenum/${this.type}`)
        .get({ params })
        .then(response => {
          this.items = response.body.items;
        });
    },
  },
};
</script>
